import { Select, Space } from 'antd';
import { getBranchListAPI, getSchoolListAPI } from 'api/common';
import { useEffect, useState } from 'react';

export const BranchSchoolSearch = ({ onSelect, branchIdx=null, schoolIdx=null, disabled=false, style }) => {
  const customStyle = {width: '20rem', ...style}

  const fnChangeBranch = (o) => {
    onSelect(o?.value, 'branch_idx', o?.label, 'branch_name')
  }

  const fnChangeSchool = (o) => {
    onSelect(o?.value, 'school_idx', o?.label, 'school_name')
  }

  return (
    <Space>
      <BranchSearch
        disabled={disabled}
        style={customStyle}
        placehold={'지사를 선택하세요.'}
        branchIdx={branchIdx}
        onSelect={fnChangeBranch}
      />
      <SchoolSearch 
        disabled={disabled}
        style={customStyle}
        placehold={'교육원을 선택하세요'}
        branchIdx={branchIdx}
        schoolIdx={schoolIdx}
        onSelect={fnChangeSchool}
      />
    </Space>
  )
};

export const BranchSearch = ({ onSelect, branchIdx=null, placehold='지사를 선택하세요.', disabled=false, style, hide=false }) => {
  const customStyle = {width: '20rem', ...style}

  const [key, setKey] = useState(0)
  const [option, setOption] = useState([])

	const fnOptionSort = (optionA, optionB) => {
		if (optionB?.value !== 'clear') {
			const labelA = optionA?.label?.toLowerCase()
			const labelB = optionB?.label?.toLowerCase()
			return labelA.localeCompare(labelB)
		}
	};

  const fnChangeBranch = (v, o) => {
    if (v === 'clear') {
			if (branchIdx) onSelect(null)
			setKey(prev => prev+1)
		} else {
			onSelect(o)
		}
  };

  const fnClearBranch = () => {
    onSelect({label: '', value: null})
  }

  const getBranchList = async () => {
    try {
      const { data } = await getBranchListAPI()
      const { data_list } = data
      const branchOption = data_list?.map(it => ({ label: it.BRANCH_NAME, value: it.IDX }))
      setOption([{label: '선택', value: 'clear'}, ...branchOption])
    } catch (err) {
      console.log(err)
    }
  };

  useEffect(() => {
    getBranchList()
  }, [])

  return (
    <div style={{ display: hide ? 'none' : '' }}>
      <Select 
        key={key}
        showSearch
        allowClear
        disabled={disabled}
        placeholder={placehold} 
        style={customStyle}
        optionFilterProp='label'
        filterSort={fnOptionSort} 
        options={option} 
        value={branchIdx} 
        onClear={fnClearBranch}
        onChange={fnChangeBranch}
      />
    </div>
  )
};

export const SchoolSearch = ({ onSelect, branchIdx=null, schoolIdx=null, placehold='교육원을 선택하세요.', disabled=false, style}) => {
  const customStyle = {width: '20rem', ...style}

  const [key, setKey] = useState(0)
  const [option, setOption] = useState([])

	const fnOptionSort = (optionA, optionB) => {
		if (optionB?.value !== 'clear') {
			const labelA = optionA?.label?.toLowerCase()
			const labelB = optionB?.label?.toLowerCase()
			return labelA.localeCompare(labelB)
		}
	};

  const fnChangeSchool = (v, o) => {
    if (v === 'clear') {
			if (schoolIdx) onSelect(null)
			setKey(prev => prev+1)
		} else {
			onSelect(o)
		}
  };

  const fnClearSchool = () => {
    onSelect({label: '', value: null})
  }

  const getSchoolList = async () => {
    if (branchIdx != null) {
      if (key === 0) { // key를 활용해서 초기 랜더링 구분
        setKey(prev => prev+1)
      } else { // 초기 랜더링이 아닌 경우, 값을 초기화 시켜준다.
        fnClearSchool()
      }

      try {
        const { data } = await getSchoolListAPI(branchIdx)
        const { data_list } = data
        const schoolOption = data_list?.map(it => ({ label: it.SCHOOL_NAME, value: it.IDX }))
        setOption([{label: '선택', value: 'clear'}, ...schoolOption])
      } catch (err) {
        console.log(err)
      }
    } else {
      if (schoolIdx) fnClearSchool()
      setOption([])
    }
  }

  useEffect(() => {
    getSchoolList()
  }, [branchIdx])

  return (
    <Select
      key={key}
      showSearch
      allowClear
      disabled={disabled}
      placeholder={placehold} 
      style={customStyle}
      optionFilterProp='label'
      filterSort={fnOptionSort} 
      options={option} 
      value={schoolIdx} 
      onClear={fnClearSchool}
      onChange={fnChangeSchool}
    />
  )
};